import React from 'react';

interface MainFileUploadProps {
    setSelectedFiles: (files: File[]) => void;
}

const MainFileUpload: React.FC<MainFileUploadProps> = ({ setSelectedFiles }) => {
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            setSelectedFiles(Array.from(event.target.files));
        }
    };

    return (
        <div className="mb-6">
            <label className="block mb-2">메인 파일 업로드</label>
            <input
                type="file"
                multiple
                onChange={handleFileChange}
                className="w-full text-sm text-gray-500 cursor-pointer file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-MainTextColor file:text-white hover:file:bg-MainColor transition duration-300 ease-in-out"
            />
        </div>
    );
};

export default MainFileUpload;
